var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.28613 4.57129H7.48633C6.36622 4.57129 5.80575 4.57129 5.37793 4.78928C5.00161 4.98102 4.69587 5.28676 4.50412 5.66309C4.28613 6.09091 4.28613 6.65138 4.28613 7.77148V8.57129M8.28613 4.57129H16.2861M8.28613 4.57129V2.57129M16.2861 4.57129H17.0863C18.2064 4.57129 18.7657 4.57129 19.1935 4.78928C19.5698 4.98102 19.8766 5.28676 20.0684 5.66309C20.2861 6.09049 20.2861 6.65028 20.2861 7.7682V8.57129M16.2861 4.57129V2.57129M4.28613 8.57129V17.3715C4.28613 18.4916 4.28613 19.0513 4.50412 19.4792C4.69587 19.8555 5.00161 20.1618 5.37793 20.3535C5.80533 20.5713 6.36513 20.5713 7.48304 20.5713H17.0892C18.2071 20.5713 18.7661 20.5713 19.1935 20.3535C19.5698 20.1618 19.8766 19.8555 20.0684 19.4792C20.2861 19.0518 20.2861 18.4928 20.2861 17.3749V8.57129M4.28613 8.57129H20.2861M16.2881 16.5713H16.2861V16.5732M12.2881 16.5713H12.2861V16.5732M8.28813 16.5713H8.28613V16.5732M16.2881 12.5713H16.2861V12.5732M12.2861 12.5713H12.2881L12.2881 12.5733M8.28613 12.5713H8.28813L8.28809 12.5733",
    stroke: "#636980",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarGrey);
export default __webpack_public_path__ + "static/media/Calendar - Grey.ef05af688658f52f54dae8ea773b3db7.svg";
export { ForwardRef as ReactComponent };